import React, { createContext, useContext, useState } from "react";

const BreadcrumbContext = createContext();

export const useBreadcrumb = () => useContext(BreadcrumbContext);

export const BreadcrumbProvider = ({ children }) => {
  const [analysisSubType, setAnalysisSubType] = useState(null);

  return (
    <BreadcrumbContext.Provider value={{ analysisSubType, setAnalysisSubType }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};
